import { Controller } from 'stimulus'
import Flickity from 'flickity'

export default class FiltersliderController extends Controller {
  static targets = ["container", "item"];

  connect() {
    this.flkty = new Flickity(this.containerTarget, {
      groupCells: true,
      pageDots: false,
      cellAlign: "left",
      contain: true,
    });

    this.containerTarget.addEventListener("click", function (event) {
      if (!this.itemTargets.includes(event.target)) {
        return;
      }
      var index = this.itemTargets.indexOf(event.target);
      this.flkty.selectCell(index);
    });

    setTimeout(() => {
      this.flkty.resize();
    }, 200);
  }

  disconnect() {
    if (this.flkty) {
      this.flkty.destroy();
    }
  }
}
